import { injectIntl } from "react-intl";
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

const formatXAxis = (value) => {
  if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(1)}M`;
  if (value >= 1_000) return `${(value / 1_000).toFixed(0)}K`;
  return value.toLocaleString();
};

const getNiceMax = (max) => {
  if (max <= 0) return 1000;
  const magnitude = 10 ** Math.floor(Math.log10(max));
  return Math.ceil(max / magnitude) * magnitude;
};

const ClicksByList = ({ data = [] }) => {
  const maxClicks = getNiceMax(Math.max(...data.map((item) => item.clicks), 0));
  const chartHeight = Math.max(data.length * 48 + 40, 120);

  return (
    <div className="SmsAnalyticsChartCard SmsAnalyticsChartCardWide">
      <div className="SmsAnalyticsChartTitle">Clicks by List</div>
      <ResponsiveContainer width="100%" height={chartHeight}>
        <BarChart
          data={data}
          layout="vertical"
          margin={{ top: 0, right: 20, left: 0, bottom: 0 }}
          barSize={24}
        >
          <CartesianGrid stroke="#F0F1F5" horizontal={false} />
          <XAxis
            type="number"
            axisLine={false}
            tickLine={false}
            tickFormatter={formatXAxis}
            tick={{ fill: "#6B7280", fontSize: 12, fontFamily: "Chakra Petch" }}
            domain={[0, maxClicks]}
          />
          <YAxis
            type="category"
            dataKey="name"
            axisLine={false}
            tickLine={false}
            width={120}
            tick={{
              fill: "#6B7280",
              fontSize: 11,
              fontFamily: "Inter",
              fontWeight: 400,
            }}
          />
          <Tooltip
            formatter={(value) => [Number(value).toLocaleString(), "Clicks"]}
            contentStyle={{
              borderRadius: 8,
              border: "1px solid #E5E7F0",
              fontSize: 12,
              fontFamily: "Inter",
            }}
          />
          <Bar dataKey="clicks" fill="#F59E0B" radius={[0, 4, 4, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default injectIntl(ClicksByList);
